import filestackClient from './filestackClient'

export default async function retrieveBase64FromFilestack(filestackHandle){

  const client = await filestackClient();
  const blob = await client.retrieve(filestackHandle);
  return new Promise(resolve => {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      var base64data = reader.result;
      resolve(base64data);
    }
  });
};



// WEBPACK FOOTER //
// ./src/lib/retrieveBase64FromFilestack.js